import client from "../client";
import { CategoryInterface } from "../../models/TicketModule/Category";

class CategoryService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/categories`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<CategoryInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/categories/getbyid/${id}`;

      const { data } = await client.get<CategoryInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(category: CategoryInterface) {
    try {
      let url = `/api/categories`;

      const { data } = await client.post<CategoryInterface>(url, category);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, category: CategoryInterface) {
    try {
      let url = `/api/categories/update/${id}`;

      const { data } = await client.post<CategoryInterface>(url, category);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/categories/remove/${id}`;
      await client.post<CategoryInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new CategoryService();
